// extracted by mini-css-extract-plugin
export default {"textColorYellow":"modalDialog_textColorYellow__gZkxO","textColorWhite":"modalDialog_textColorWhite__0ZIvo","buttonStyle":"modalDialog_buttonStyle__dVdLx"};